import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import APModal from 'components/Modal/APModal';
import { updateChecklistDates } from 'apollo/projects.query';
import ErrorModal from './ErrorModal';
import './styles.scss';

const ChecklistDatesModal = ({ open, onClose, weddingId, originalDate }) => {
  const [isChecklistDatesChanged, setChecklistDatesChanged] = useState(false);
  const [openCreateProjectError, setOpenCreateProjectError] = useState(false);
  const [errMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (!open) {
      setChecklistDatesChanged(false);
    }
  }, [open]);

  const updateDates = async () => {
    try {
      const data = await updateChecklistDates({
        id: weddingId,
        weddingBody: {
          date: new Date(originalDate).toLocaleDateString('fr-CA'),
        },
      });
      if (data.updateChecklistDates.success) {
        setChecklistDatesChanged(true);
      } else {
        setErrorMessage(
          "Sorry, we couldn't change the checklist dates.  Please try again.",
        );
        setOpenCreateProjectError(true);
      }
    } catch (err) {
      setErrorMessage(
        "Sorry, we couldn't change the checklist dates.  Please try again.",
      );
      setOpenCreateProjectError(true);
    }
  };

  return (
    <>
      <APModal
        open={open}
        title={isChecklistDatesChanged ? 'We got you!' : 'You\'re all set!' }
        name='checklist-dates'
        onClose={onClose}
        actions={isChecklistDatesChanged ? (
          <button
            className="checklist-dates-modal__submit"
            onClick={onClose}
          >
            Done and done
          </button>
        ) : (
          <>
            <button
              className="checklist-dates-modal__submit"
              onClick={() => updateDates()}
            >
              Yes, update checklist due dates
            </button>
            <button
              className="checklist-dates-modal__submit"
              onClick={onClose}
            >
              No, i'll make any changes manually
            </button>
          </>
        )}
      >
        {isChecklistDatesChanged ? (
          <>
            We’ve updated this project’s checklist due dates
            <br />
            and any due date reminders.
          </>
        ) : (
          <>
            This project’s date has been changed! Do you also want to
            update all the due dates and due date reminders on this
            project’s checklist?
          </>
        )}
      </APModal>
      <ErrorModal
        open={openCreateProjectError}
        onClose={() => {
          setErrorMessage(null);
          setOpenCreateProjectError(false);
        }}
      >
        <div className="body-content container--small">
          <div>{errMessage}</div>
        </div>
      </ErrorModal>
    </>
  );
};

ChecklistDatesModal.propTypes = {
  onClose: PropTypes.func,
};

ChecklistDatesModal.defaultProps = {};

export default ChecklistDatesModal;
